import {useSessionStore} from '@/stores'
import {useEventBus} from '@vueuse/core'

export const useConnectionsCallback = () => {
  const session = useSessionStore()

  useEventBus('strategy:connections').on((data: any) => {
    session.updateConnections(data)
  })
}
